module.exports = __webpack_public_path__ + "static/media/fz_schdview_pt_BR.2af14c3a.png";